import '../sass/main.scss';

import 'owl.carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';

import '@fancyapps/fancybox';
import '@fancyapps/fancybox/dist/jquery.fancybox.min.css';

// Helpers
import './helpers/index';

// Search
import './search';

// Admin bar Corrections
import './adminBarCorrection';

// Share social buttons
import './shareSocialBtn';

// Ajax
import './ajax';

$(document).ready(function () {

  $('.editorial-title a.pill').click(function(event){
    event.preventDefault();
    var varAlvo = $(this).data('href');
    $(varAlvo).addClass('active').siblings().removeClass('active');
    $(this).addClass('active').siblings().removeClass('active');
    return false;
  });
  
	//HOME OWL
	function postsCarousel() {
		var checkWidth = $(window).width();
      
      var owlParceiros = $(".partners-images");
			owlParceiros.owlCarousel({
		        loop: true,
		        autoplay : true,
		        autoplayTimeout:2000,
            nav: false,
            dots:true,
            margin: 10,
            items:3,
            responsive : {
              0 : {
                dots:true,
                items:2
              },
              768 : {
                dots:true,
                nav: true,
                items:3
              }
          }
            
			});
	}

	postsCarousel();
	

  var offset = $('.header').offset().top;
  var $meuMenu = $('.header'); // guardar o elemento na memoria para melhorar performance
  $(document).on('scroll', function () {
      if (100 <= $(window).scrollTop()) {
          $meuMenu.addClass('fixed');
          $('body').css('margin-top', '350px');
      } else {
          $meuMenu.removeClass('fixed');
          $('body').css('margin-top', '0px');
      }
  });

  const $headerMobile = $('.header-mb')
  const $menuMobileCheckbox = $('.grid-menu input[type="checkbox"]')

  $menuMobileCheckbox.on('click', function () {
    if ($menuMobileCheckbox.is(':checked') == true) {
      setTimeout(() => {
        $headerMobile.addClass('header-mb-fixed')
      }, 150)
    } else {
      $headerMobile.removeClass('header-mb-fixed')
    }
  })

  const owlCarousel = $('#owl-carousel')
  if (owlCarousel) {
    owlCarousel.owlCarousel({
      items: 1,
      loop: true,
      lazyLoad: true,
      autoplay: true,
      autoHeight: true,
      autoplayTimeout: 5000,
      autoplayHoverPause: true,
      nav: true,
      responsive : {
        0 : {
          dots:true
        },
        768 : {
          dots:false
        }
    }
    })
  }

  let $liMenuAncora = $('li.ancora a');
  if ($liMenuAncora) {
    $liMenuAncora.click(function () {
      var alvo = $(this).attr('href').split('#').pop();
      $('html, body').animate({ scrollTop: $('#' + alvo).offset().top }, 1000);
      return false;
    });
  }

  /* LGPD cookies control - start */
  const $cookiesElement = $('.cookie-lgpd-popup');
  if (getCookie('ciencia-pioneira-wp-politicas-lgpd') != 'true' && $cookiesElement) {
    $cookiesElement.addClass('active');

    $cookiesElement.find(".btn-close").on('click tap touchstart', function () {
      $cookiesElement.removeClass('active');
    });

    $cookiesElement.find("[data-js='lgpd-proceed']").on('click tap touchstart', function () {
      setCookie('ciencia-pioneira-wp-politicas-lgpd', 'true', 365);
    });
  }
  /* LGPD cookies control - end */

});


window.onload = () => {
  setTimeout(() => {
    clickOnHrefItens(-400);

    hashGoToElementAnchor(-400);
  }, 500);
}